/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Secrets_TitleInputs */

const en_rd_secrets_title = /** @type {(inputs: Rd_Secrets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Possible secrets in the repo`)
};

const id_rd_secrets_title = /** @type {(inputs: Rd_Secrets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dugaan kunci rahasia di repo`)
};

/**
* | output |
* | --- |
* | "Possible secrets in the repo" |
*
* @param {Rd_Secrets_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_secrets_title = /** @type {((inputs?: Rd_Secrets_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Secrets_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_secrets_title(inputs)
	return en_rd_secrets_title(inputs)
});